import React from 'react';
import { CatalogMapCatalogItemViewModel } from '@common/model/catalog/item/map.view';
import { MapMarkerConfig } from 'src/app/shared/components/map/model';

export const useMapMarkers = (locations: CatalogMapCatalogItemViewModel[]) => {
  const markers = React.useMemo<MapMarkerConfig<number>[] | undefined>(() => {
    return locations.map((item) => {
      const { id, location, clientProfile } = item;

      return {
        id,
        location: location || (clientProfile.location as string),
        iconUrl: '/img/map-mark-icon__default.svg',
      };
    });
  }, [locations]);

  return { markers };
};
